
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 4.933a2.666 2.666 0 100 5.334 2.666 2.666 0 100-5.334zm5.96 2A5.996 5.996 0 008.667 1.64V.267H7.333V1.64A5.996 5.996 0 002.04 6.933H.667v1.334H2.04a5.996 5.996 0 005.293 5.293v1.373h1.334V13.56a5.996 5.996 0 005.293-5.293h1.373V6.933H13.96zM8 12.267A4.663 4.663 0 013.333 7.6 4.663 4.663 0 018 2.933 4.663 4.663 0 0112.667 7.6 4.663 4.663 0 018 12.267z"}})])
          )
        }
      }
    